// Enhances association detail pages with a responsive carousel and gallery modal.
import { createApp } from 'vue';

import Carousel from '../components/general/carousel.vue';
import Slide from '../components/general/carousel-slide.vue';
import ListingGallery from '../components/property/listing-gallery.vue';
import getWindowSize from '../helpers/getWindowSize';

const associationElement = document.getElementById('association-container');

if (associationElement) {
    const associationApp = createApp({
        components: {
            ListingGallery,
            Carousel,
            Slide,
        },
        data() {
            return {
                windowSize: getWindowSize(),
                showGallery: false,
                galleryIndex: 0,
            };
        },
        computed: {
            perPage() {
                return ['md', 'lg', 'xl'].includes(this.windowSize) ? 2 : 1;
            },
        },
        mounted() {
            window.addEventListener('resize', this.updateWindowSize);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.updateWindowSize);
        },
        methods: {
            updateWindowSize() {
                this.windowSize = getWindowSize();
            },
            openGallery(index = 0) {
                this.galleryIndex = index;
                this.showGallery = true;
            },
            closeGallery() {
                this.showGallery = false;
            },
            prevPhoto() {
                this.galleryIndex = this.galleryIndex > 0
                    ? this.galleryIndex - 1
                    : window.galleryLength - 1;
            },
            nextPhoto() {
                this.galleryIndex = this.galleryIndex < window.galleryLength - 1
                    ? this.galleryIndex + 1
                    : 0;
            },
            getSlideSize(index, slideIndex, galleryCount, slideCount) {
                const onLastSlide = slideIndex === slideCount;
                const remainder = galleryCount % 4;
                const oneBasedIndex = index + 1;

                if (onLastSlide && remainder === 1 && oneBasedIndex === 1) {
                    return 'w-full h-full';
                }
                if (onLastSlide && (remainder === 2 || (remainder === 3 && oneBasedIndex === 1))) {
                    return 'w-full h-1/2';
                }
                return 'w-1/2 h-1/2';
            },
        },
    });

    associationApp.config.compilerOptions.whitespace = 'preserve';
    associationApp.mount(associationElement);
}

const footerElement = document.getElementById('footer-cta');
if (footerElement) {
    const footerApp = createApp({});
    footerApp.config.compilerOptions.whitespace = 'preserve';
    footerApp.mount(footerElement);
}
